import { Box, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { submissionIconAndType } from "utilities/forms"
import { useCurrentEvent } from "queries/events"
import React from "react"
import { useHistory, useParams } from "react-router"
import { FormType, SubmissionLineItem } from "sharedTypes"
import { eventDataCollectionFormSubmissionPath } from "utilities/routes"
import { asDate, asMoney } from "utilities/strings"
import chakraColors from "theme/chakraColors"

type Props = {
  submitterName: string
  submitterEmail: string
  lineItems: SubmissionLineItem[]
  price: string
  createdAt: string
  externalId: string
}

const FormSubmissionListItem = ({
  submitterName, submitterEmail, lineItems, price, createdAt, externalId,
}: Props) => {
  const history = useHistory()
  const { data: { id: eventId, currency } } = useCurrentEvent()
  const { submissionId } = useParams<{ submissionId: string }>()

  const handleClick = () => {
    history.push(
      eventDataCollectionFormSubmissionPath(eventId, externalId),
    )
  }

  let listItemNameAndIcon = <Flex />
  const showPrice = Boolean(lineItems.find(
    ({ form: { type: lineItemFormType } }) => lineItemFormType === FormType.Ticket,
  ))

  if (lineItems.length !== 0) {
    const { icon, type } = submissionIconAndType(lineItems)

    listItemNameAndIcon = (
      <Flex>
        <Icon icon={icon} size={5} mr={2} />
        <Text fontSize="smaller" fontWeight={lineItems.length > 1 ? "bold" : undefined}>{type}</Text>
      </Flex>
    )
  }

  return (
    <Box
      borderBottomWidth={1}
      p={4}
      onClick={handleClick}
      cursor="pointer"
      backgroundColor={submissionId === externalId ? chakraColors.ui.selectedItemBg : ""}
    >
      <Flex justifyContent="space-between">
        {listItemNameAndIcon}
        <Flex>
          {showPrice && <Text mr={6}>{asMoney(price, currency)}</Text>}
          <Text>{asDate(createdAt, "M/d/y")}</Text>
        </Flex>
      </Flex>
      <Text>{submitterName}</Text>
      <Text fontSize="smaller">{submitterEmail}</Text>
    </Box>
  )
}

export default FormSubmissionListItem
